module.exports = __webpack_public_path__ + "img/oem_logo_1104.fae5dd59.png";